type GetPageData = <T>(pageNumber: number, data: T[], perPage?: number) => T[]

const DEFAULT_PER_PAGE = 5

const getPageData: GetPageData = (
  pageNumber,
  data,
  perPage = DEFAULT_PER_PAGE,
) => {
  const start = (pageNumber - 1) * perPage
  const end = start + perPage
  return data.slice(start, end)
}

export default getPageData
